var _rect, _rect2, _rect3, _rect4, _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 18.8574,
    width: 18.2731,
    height: 5.81416,
    rx: 2.90708,
    fill: "#FFF7B3",
    stroke: "#C7C9CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.32239,
    y: 1,
    width: 18.2731,
    height: 5.81416,
    rx: 2.90708,
    fill: "#FFF7B3",
    stroke: "#C7C9CE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.81445,
    width: 18.2731,
    height: 5.81416,
    rx: 2.90708,
    fill: "#FFF7B3",
    stroke: "#C7C9CE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.49219,
    y: 12.6289,
    width: 18.2731,
    height: 5.81416,
    rx: 2.90708,
    fill: "#FFF7B3",
    stroke: "#C7C9CE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1353,
    cy: 18.2369,
    rx: 9.75248,
    ry: 9.76233,
    fill: "#FFEB3B",
    stroke: "#7A7E88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1853 24.6377C20.9388 24.6377 20.7306 24.5508 20.5606 24.3769C20.3906 24.2031 20.3056 23.9858 20.3056 23.725V22.7603L20.6881 23.1123C20.1186 23.0862 19.6257 23.0123 19.2092 22.8906C18.7927 22.769 18.4528 22.6473 18.1893 22.5256C17.9683 22.4213 17.8111 22.2735 17.7176 22.0823C17.6326 21.8911 17.5986 21.6955 17.6156 21.4956C17.6411 21.2957 17.7133 21.1132 17.8323 20.948C17.9513 20.7829 18.1043 20.6743 18.2913 20.6221C18.4868 20.5613 18.712 20.5873 18.967 20.7003C19.137 20.7959 19.3919 20.8959 19.7319 21.0002C20.0804 21.0958 20.5096 21.1436 21.0196 21.1436C21.3765 21.1436 21.657 21.1088 21.861 21.0393C22.0735 20.9698 22.2222 20.8785 22.3072 20.7655C22.4007 20.6438 22.4475 20.5135 22.4475 20.3744C22.4475 20.244 22.4135 20.1354 22.3455 20.0485C22.286 19.9528 22.184 19.8703 22.0395 19.8007C21.895 19.7225 21.6953 19.653 21.4403 19.5921L19.9996 19.2792C19.2092 19.0967 18.6185 18.7925 18.2275 18.3666C17.8451 17.932 17.6538 17.3714 17.6538 16.6848C17.6538 16.1633 17.7771 15.6983 18.0235 15.2898C18.2785 14.8725 18.6313 14.5336 19.0817 14.2728C19.5407 14.0121 20.0761 13.8469 20.6881 13.7774L20.3056 13.999V13.1255C20.3056 12.8648 20.3906 12.6475 20.5606 12.4736C20.7306 12.2998 20.9388 12.2129 21.1853 12.2129C21.4403 12.2129 21.6528 12.2998 21.8228 12.4736C21.9927 12.6475 22.0777 12.8648 22.0777 13.1255V13.999L21.6953 13.7513C22.0182 13.76 22.3667 13.8165 22.7407 13.9208C23.1147 14.0164 23.4419 14.1511 23.7224 14.325C23.9179 14.4293 24.0538 14.5727 24.1303 14.7552C24.2153 14.9377 24.2451 15.1246 24.2196 15.3158C24.2026 15.4984 24.1346 15.6635 24.0156 15.8113C23.9051 15.959 23.7521 16.059 23.5566 16.1111C23.3696 16.1546 23.1444 16.1198 22.8809 16.0068C22.6854 15.9199 22.4645 15.8504 22.218 15.7982C21.98 15.7374 21.674 15.707 21.3 15.707C20.8496 15.707 20.5011 15.7895 20.2546 15.9547C20.0166 16.1198 19.8977 16.3328 19.8977 16.5935C19.8977 16.7673 19.9656 16.9151 20.1016 17.0368C20.2461 17.1498 20.5054 17.2497 20.8793 17.3366L22.3327 17.6626C23.1402 17.8451 23.7351 18.1493 24.1176 18.5752C24.5086 18.9924 24.704 19.5356 24.704 20.2049C24.704 20.7264 24.5808 21.1871 24.3343 21.5869C24.0878 21.9867 23.7436 22.3126 23.3016 22.5647C22.8682 22.8168 22.3625 22.9819 21.7845 23.0601L22.0777 22.7472V23.725C22.0777 23.9858 21.9927 24.2031 21.8228 24.3769C21.6613 24.5508 21.4488 24.6377 21.1853 24.6377Z",
    fill: "#7A7E88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.f927485ea1ec176bb37119edb240c8b8.svg";
export { ForwardRef as ReactComponent };